import React from 'react';
import { updateSpace } from '../../app-main/actions/space';
import { SubmissionError } from 'redux-form';
import { get, filter } from 'lodash';
import { FormattedMessage } from 'react-intl';

const onSubmitParking = (values = {}, dispatch, props) => {
  const { spaceId, accessToken } = props;
  const types = get(values, 'types', {});
  let payload = {};

  if ('true' === values.is_available) {
    payload.parking_info = {
      types: filter(types, (value) => value),
      description: values.description,
      is_available: true
    };
  } else {
    payload.parking_info = {
      is_available: false
    };
  }

  if ('true' === values.has_surveillance) {
    payload.surveillance_info = {
      has_surveillance: true,
      description: values.surveillance_description
    };
  } else {
    payload.surveillance_info = {
      has_surveillance: false
    };
  }
  const errorMessage = <FormattedMessage id="hosting.on_submit_parking.error_message" defaultMessage="Submission failed. Please refresh and try again." />;

  return dispatch(updateSpace(spaceId, accessToken, payload))
    .then(() => {
      // NOTE: add analytics here
      window.location.href = '/mylistings';
    })
    .catch(() => {
      throw new SubmissionError({ _error: errorMessage });
    });
};

export default onSubmitParking;
